import { ReloadRegistrationPeriod } from '../../../store/actions/registration-period.action';
import { companyProductSelectionActionLoading } from '../../../store/reducer/company-product-selection.reducer';
import { AddUpdateRemoveCompanyProductSelectionAttributes } from '../../../store/actions/company-product-selection.actions';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { LoadProductsByIds } from 'src/app/store/actions/product.actions';
import { companyProductSelectionWithMetaById, selectedCompanyId, selectedRegistrationPeriodId } from 'src/app/store/store';
import { AttributeListV2Component } from '../../components/attribute-list-v2/attribute-list-v2.component';
import { waitForBooleanValue } from '../../utils';
import { filter, map, Observable, take } from 'rxjs';
import { CompanyProductSelectionWithMeta } from 'src/app/store/entity-models';
import { ProductPriceScaleDetails } from '@iota/iota-management-portal-v4-client';
import { AsyncState } from '../../utils/async-state.util';

export interface DialogConfigureRegistrationProductData {
    companyProductSelectionId: string;
    productId: string;
}

@Component({
    standalone: false,
    selector: 'app-dialog-configure-registration-product',
    templateUrl: './dialog-configure-registration-product.component.html',
    styleUrls: ['./dialog-configure-registration-product.component.scss']
})
export class DialogConfigureRegistrationProductComponent implements OnInit {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SIZE_7XL,
        showToggleFullScreenButton: true,
        scroll: 'only-y'
    };

    companyProductSelection$: Observable<CompanyProductSelectionWithMeta>;
    priceScaleState$: Observable<AsyncState<ProductPriceScaleDetails | null>>;
    selectedCompanyId$ = this.store.select(selectedCompanyId);
    @ViewChild('attributeList') attributeList: AttributeListV2Component;

    editMode = false;

    constructor(
        private store: Store,
        public dialogRef: MatDialogRef<DialogConfigureRegistrationProductComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfigureRegistrationProductData
    ) {
        this.companyProductSelection$ = this.store.select(companyProductSelectionWithMetaById(this.data.companyProductSelectionId));
        this.priceScaleState$ = this.companyProductSelection$.pipe(
            map(
                (selection): AsyncState<ProductPriceScaleDetails | null> => ({
                    status: 'ok',
                    data: selection?.productDetails?.priceScale ?? null
                })
            )
        );
    }

    ngOnInit(): void {
        this.store.dispatch(LoadProductsByIds({ productIds: [this.data.productId] }));
    }

    edit(): void {
        this.editMode = !this.editMode;
    }

    cancel(): void {
        this.editMode = false;
    }

    async save() {
        if (this.attributeList.hasValidationErrors()) {
            this.attributeList.showValidationErrorNotification();
            return;
        }

        const attributeResult = this.attributeList.getAttributeListResult();
        const attributesChanged = attributeResult?.upsertedAttributes?.length > 0 || attributeResult?.removedAttributeIds?.length > 0;

        if (attributesChanged) {
            this.store.dispatch(
                AddUpdateRemoveCompanyProductSelectionAttributes({
                    attributeResult,
                    companyProductSelectionId: this.data.companyProductSelectionId
                })
            );
        }
        this.editMode = false;

        await waitForBooleanValue(this.store, companyProductSelectionActionLoading, false);
        this.store
            .select(selectedRegistrationPeriodId)
            .pipe(
                filter((x) => !!x),
                take(1)
            )
            .subscribe((id) => {
                this.store.dispatch(ReloadRegistrationPeriod({ registrationPeriodId: id }));
            });
    }

    close() {
        this.dialogRef.close();
    }
}
